import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { OperateBorderLines } from '@/types/edit'


export default /*#__PURE__*/_defineComponent({
  __name: 'BorderLine',
  props: {
    type: {},
    isWide: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['border-line', _ctx.type, { 'wide': _ctx.isWide }])
  }, null, 2))
}
}

})